import { useMutation, useQueryClient } from '@tanstack/react-query'

import { reviewsApi, reviewKeys } from '../lib'

import type { ReviewFormValues, CreateProductReviewRequest } from '../types'

/**
 * Hook to create a product review
 * Automatically invalidates review queries on success
 */
export function useCreateReview() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (reviewData: ReviewFormValues) => {
      // ReviewFormValues matches CreateProductReviewRequest structure
      const input: CreateProductReviewRequest = {
        sku: reviewData.sku,
        nickname: reviewData.nickname,
        summary: reviewData.summary,
        text: reviewData.text,
        ratings: reviewData.ratings,
      }

      return reviewsApi.createReview(input)
    },
    onSuccess: (_, variables) => {
      // Invalidate all review queries for this SKU (regardless of pagination params)
      void queryClient.invalidateQueries({
        queryKey: reviewKeys.lists(variables.sku),
      })
    },
  })
}
